import { useEffect, useCallback, useState } from 'react';
import { Modal, Typography, Button, Collapse } from 'antd';
import TerritoryService from 'services/territorio';
import xlsIcon from 'assets/img/formats/xls.png';
import pdfIcon from 'assets/img/formats/pdf.png';
import csvIcon from 'assets/img/formats/csv.png';
import jsonIcon from 'assets/img/formats/json.png';
import Utils from 'utils';
import moment from 'moment';
import {
  faFilePdf,
  faFileExcel,
  faFileCode,
  faFileLines
} from '@fortawesome/free-regular-svg-icons';
import { CloseOutlined, InfoCircleOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../css/_reportHead.scss';
const { Title } = Typography;

function ReportHead({ date, headerFunction, setLoading, setHeaderFunction }) {
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [visibleVariables, setVisibleVariables] = useState(false);

  const { Panel } = Collapse;

  const infoIcon = (
    <InfoCircleOutlined aria-label={null} role={null} />
  )
  const closeIcon = (
    <CloseOutlined aria-label={null} />
  )

  const detailContent = (obj) => {
    return (
      <>
        <div className="descrizioneReport mb-2">
          <div>{obj.guida}</div>
        </div>
        <div className="territory-variable-detail">
          <div>
            <div className="detail-title">Variabile</div>
            <div>{obj.variabile}</div>
          </div>
          <div>
            <div className="detail-title">Acronimo Variabile</div>
            <div>{obj.colname ? obj.colname : 'Non presente'}</div>
          </div>
          <div>
            <div className="detail-title">Note</div>
            <div>{obj.note}</div>
          </div>
          <div>
            <div className="detail-title">Fonte</div>
            <div>{obj.fonte}</div>
          </div>
          <div>
            <div className="detail-title">Link</div>
            <div>{obj.link ? <a className="infomodal-accordion-link" href={obj.link} target='_blank' title={`Apri finestra verso ${obj.link}`}>{obj.link}</a> : 'Non presente'}</div>
          </div>
        </div>
      </>
    );
  }

  // NEL CASO SERVISSE ENUNCIARE IL CONTENUTO DELL'ACCORDION ALL'APERTURA
  // const enunciateContent = (obj) => {
  //   let innerText = '';
  //   if (obj) {
  //     innerText = 'Definizioni: ' +
  //                 'Variabile: ' + obj.variabile + '. ' +
  //                 'Acronimo Variabile: ' + (obj.colname ? obj.colname : 'Non presente') + '. ' +
  //                 'Note: ' + (obj.note && obj.note !== 'Nessuna nota' ? obj.note + ' ' : 'Nessuna nota. ') +
  //                 'Fonte: ' + obj.fonte + '. ' +
  //                 'Link: ' + (obj.link ? obj.link : 'Non presente') + '.';
  //   }
  //   const status = document.getElementById('info-modal-collapse-definitions');
  //   if(status) status.innerText = innerText;
  // }

  const downloadHeaders = ["Variabile", "Acronimo variabile", "Descrizione", "Note", "Fonte", "Link"];

  const fetchHeader = async (date, funzione) => {
    return await TerritoryService.header(date, funzione);
  };

  const headerVariables = useCallback(
    (formattedData) => {
      return (
        <>
          <div className="territorial-units-download d-flex justify-content-end align-items-center">
            <Button
              className="button-istat-svgpath"
              size="large"
              title="Scarica tabella report in PDF"
              aria-label="Scarica tabella report in PDF"
              icon={
                <FontAwesomeIcon
                  aria-hidden="true"
                  style={{ width: '27px', height: '27px' }}
                  icon={faFilePdf}
                  size="2xl"
                />
              }
              onClick={() =>
                Utils.exportPDF(
                  'Legenda ' +
                  headerFunction.titolo_report +
                  ' - Data stampa ' +
                  moment().format('DD/MM/YYYY'),
                  [
                    { title: downloadHeaders[0] },
                    { title: downloadHeaders[1] },
                    { title: downloadHeaders[2] },
                    { title: downloadHeaders[3] },
                    { title: downloadHeaders[4] },
                    { title: downloadHeaders[5] },
                  ],
                  formattedData.map((obj) => [obj.variabile, obj.colname, obj.guida, obj.note, obj.fonte, obj.link]),
                  'landscape'
                )
              }>
            </Button>
            <Button
              className="button-istat-svgpath"
              title="Scarica tabella report in XLSX"
              aria-label="Scarica tabella report in XLSX"
              icon={
                <FontAwesomeIcon
                  aria-hidden="true"
                  style={{ width: '27px', height: '27px' }}
                  icon={faFileExcel}
                  size="2xl"
                />
              }
              onClick={() =>
                Utils.exportXLSX(
                  'Legenda report ' +
                  headerFunction.titolo_report +
                  ' - Data stampa ' +
                  moment().format('DD/MM/YYYY'),
                  downloadHeaders,
                  formattedData.map(({ note, variabile, guida, fonte, link, colname }) => ({
                    variabile,
                    colname,
                    guida,
                    note,
                    fonte,
                    link
                  }))
                )
              }>
            </Button>
            <Button
              className="button-istat-svgpath"
              title="Scarica tabella report in CSV"
              aria-label="Scarica tabella report in CSV"
              icon={
                <FontAwesomeIcon
                  aria-hidden="true"
                  style={{ width: '27px', height: '27px' }}
                  icon={faFileLines}
                  size="2xl"
                />
              }
              onClick={() =>
                Utils.exportCSV(
                  'Legenda report ' +
                  headerFunction.titolo_report +
                  ' - Data stampa ' +
                  moment().format('DD/MM/YYYY'),
                  downloadHeaders,
                  ['variabile', 'colname', 'guida', 'note', 'fonte', 'link'],
                  formattedData.map(({ variabile, colname, guida, note, fonte, link }) => ({
                    variabile,
                    colname,
                    guida,
                    note,
                    fonte,
                    link
                  })),
                  ';'
                )
              }>
            </Button>
            <Button
              className="button-istat-svgpath"
              title="Scarica tabella report in JSON"
              aria-label="Scarica tabella report in JSON"
              icon={
                <FontAwesomeIcon
                  aria-hidden="true"
                  style={{ width: '27px', height: '27px' }}
                  icon={faFileCode}
                  size="2xl"
                />
              }
              onClick={() => {
                const jsonFormatted = formattedData.map(
                  ({ note, variabile, guida, fonte, link, colname }) => ({
                    variabile,
                    "acronimo variabile":colname,
                    guida,
                    note,
                    fonte,
                    link
                  })
                );
                const fileData = JSON.stringify(jsonFormatted);
                const blob = new Blob([fileData], { type: 'text/plain' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download =
                  'Legenda report ' +
                  headerFunction.titolo_report +
                  ' - ' +
                  moment().format('DD_MM_YYYY_HHmmss') +
                  '.json';
                link.href = url;
                link.click();
              }}>
            </Button>
          </div>
          <div className="w-100 mb-4 descrizioneReport">{headerFunction?.descrizione_report}</div>
          <div className="reportHeadMain">
            {/* <span id="info-modal-collapse-definitions" className="sr-only" role="status" aria-live="polite"></span> */}
            <h2 className="variabiliTitle">Variabili</h2>
            <Collapse
              style={{ display: 'contents' }}
              aria-live="polite"
              aria-atomic={true}
              expandIcon={({ isActive }) =>
                !isActive ? (
                  <PlusCircleOutlined aria-label='Espandi' style={{ fontSize: '15px' }} />
                ) : (
                  <MinusCircleOutlined aria-label="Chiudi" style={{ fontSize: '15px' }} />
                )
              }
              // NEL CASO SERVISSE ENUNCIARE IL CONTENUTO DELL'ACCORDION ALL'APERTURA
              // onChange={(value) => {
              //   if (value) {
              //     const current = formattedData.find(obj => obj?.variabile === value);
              //     enunciateContent(current);
              //   }
              // }}
              className="elements-container">
              {formattedData.map((obj, index) => (
                <Panel
                  header={
                    <span id={'collapseheader-' + index} style={{ fontSize: '1.1rem', fontWeight: 500, color: 'black' }}>{`${obj.variabile} [${obj.colname ?? ""}]`}</span>
                  }
                  key={obj.variabile}>
                  {detailContent(obj)}
                </Panel>
              ))}
            </Collapse>
          </div>
        </>
      );
    },
    [headerFunction, visibleDetails]
  );

  useEffect(() => {
    let unmounted = false;
    if (headerFunction && !unmounted) {
      setLoading(true);
      fetchHeader(date?.replaceAll('/', '-'), headerFunction.id_funzione)
        .then(({ data }) => {
          const labelArray = data.label.split('§');
          const formattedData = labelArray.map((label, i) => {
            const fonte = data.fonte.split('§')[i].trim();
            const guida = data.guida.split('§')[i].trim();
            const link = data.link.split('§')[i].trim();
            const note = data.note.split('§')[i].trim();
            const colname = data.colname.split('§')[i].trim();
            const obj = { variabile: label.trim(), note, link, guida, fonte, colname };
            return obj;
          });
          setLoading(false);
          const titleFinish = (
            <Title id='report-head' className="reportHeadH1">{headerFunction.titolo_report}</Title>
          );
          Modal.info({
            tabIndex: -1,
            width: 800,
            title: titleFinish,
            icon: infoIcon,
            closeIcon: closeIcon,
            closable: true,
            visible: visibleVariables,
            autoFocusButton: null,
            centered: true,
            onCancel: () => {
              setVisibleVariables(false);
              setHeaderFunction();
            },
            content: headerVariables(formattedData),
            okButtonProps: {
              style: { backgroundColor: '#426F80', border: 0, borderRadius: '5px' },
            },
            okText: 'Chiudi',
            onOk: () => {
              setVisibleVariables(false);
              setHeaderFunction();
            }
          });
          setTimeout(
            () => {
              document.getElementsByClassName('ant-modal-close')[0].setAttribute('aria-label', 'Chiudi');
              var modal = document.getElementsByClassName('ant-modal-wrap')[0];
              modal.setAttribute('aria-modal', 'true');
              modal.setAttribute('aria-labelledby', 'report-head');
            }, 100
          );
        })
        .catch(() => setLoading(false));
    }

    return () => {
      unmounted = true;
    };
  }, [headerFunction, date, visibleVariables, headerVariables, setHeaderFunction, setLoading]);

  return <></>;
}

export default ReportHead;
